import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as messageAlert from '../../actions/messageAlertAction';
import CustomIcon from '../common/CustomIcon';
import * as classroomApi from '../../services/api/classroomApi';
import FileDownloaderService from '../../services/stream/FileDownloadService';
import GeneratePinCodesAgainReveal from './reveal/GeneratePinCodesAgainReveal';
import * as revealActions from '../../actions/revealActions';
import * as classroomActions from '../../actions/classroom/classroomActions';
import { getLogger } from '../../services/logger';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { ROUTES } from '../../const';
import SmartLoader from '../common/SmartLoader/SmartLoader';

const debug = getLogger('components:classroom:ClassroomSettings');

class ClassroomSettings extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.printClassroomStudentProfiles = this.printClassroomStudentProfiles.bind(this);
    this.state = {
      open: false,
      showModalPinCodes: false,
      active: false
    };
    this.importCSV = this.importCSV.bind(this);
  }

  static propTypes = {
    classroomActions: PropTypes.any,
    classroom: PropTypes.any,
    revealActions: PropTypes.any,
    messageAlert: PropTypes.any,
    printStudentProfile: PropTypes.any,
    selectedBook: PropTypes.any,
    colors: PropTypes.any,
    pinCodesRevealOpen: PropTypes.any,
    student: PropTypes.any,
    pathname: PropTypes.any,
    gearSize: PropTypes.number
  };

  handlerClick(e) {
    const { open } = this.state;
    e.preventDefault();

    this.setState({
      open: !open
    });
  }

  importCSV() {
    const { classroomActions } = this.props;
    classroomActions.setImportCSVModalState(true);
  }

  handlerClose() {
    this.setState({
      open: false
    });
  }

  printClassroomStudentProfiles = () => {
    const { classroom, revealActions } = this.props;
    classroomApi
      .getClassroomStudentPinCodes(classroom.sectionId)
      .then(dataStream => {
        FileDownloaderService.downloadFromRawBinaryStream(dataStream.data, `${classroom.name}_pincode`, '.pdf');
      })
      .catch(err => {
        debug.error('error getting the students pin codes %s', err);
        revealActions.openPinCodesReveal();
      });
    this.handlerClose();
  };

  defaultFunction() {
    const { messageAlert } = this.props;
    messageAlert.notImplementedYet();
    this.handlerClose();
  }

  getOptions() {
    let options = [];
    let { printStudentProfile, selectedBook, pathname } = this.props;
    const inGradeBook = new RegExp(ROUTES.REGEXP.GRADEBOOK).test(pathname);

    if (printStudentProfile) {
      options.push(
        <Link key={1}>
          <div className="item link" onClick={() => this.printClassroomStudentProfiles()}>
            <span className="icon">
              <CustomIcon name="office-paper-printer" size={16} />
            </span>
            <span className="text">{I18n.t('classroomSettings.printStudentsProfiles')}</span>
          </div>
        </Link>
      );
    }

    return options;
  }

  renderOptions() {
    const { colors, pinCodesRevealOpen, revealActions, classroom, student, gearSize } = this.props;
    const { open, active } = this.state;
    let showLarge = open ? 'show-large' : '';
    let show = open ? 'show' : '';

    return (
      <div className="custom-drop-down-options float-right" onBlur={this.handlerClose.bind(this)} tabIndex="-2">
        <div className="options-drop-down-pane" onClick={this.handlerClick.bind(this)}>
          <h5>
            <CustomIcon name="options-gear" size={gearSize || 24} />
          </h5>
        </div>
        <div className={`custom-drop-down-pane down ${showLarge}`}>
          <div className={`custom-drop-down-pane-content ${show}`}>
            <div className="classroom-settings">{this.getOptions()}</div>
          </div>
          <GeneratePinCodesAgainReveal
            classroom={classroom}
            colors={colors}
            active={pinCodesRevealOpen}
            student={student}
            onClose={revealActions.closePinCodesReveal}
          />
        </div>
        <SmartLoader
          active={active}
          style={{ loader: { position: 'fixed', left: '0' } }}
          text={I18n.t('classroomSettings.exportingGrades')}
        />
      </div>
    );
  }

  render() {
    return !_.isEmpty(this.getOptions()) ? this.renderOptions() : null;
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    classroom: state.classrooms.selectedClassroom.classroom,
    colors: state.theme.colors,
    pinCodesRevealOpen: state.reveal.pinCodesRevealOpen,
    student: state.reveal.student,
    printStudentProfile: state.account.configuration.printStudentProfile,
    selectedBook: state.gradebook.selectedBook,
    pathname: state.router.location.pathname
  };
}

function mapDispatchToProps(dispatch) {
  return {
    messageAlert: bindActionCreators(messageAlert, dispatch),
    revealActions: bindActionCreators(revealActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomSettings);
